import {connect} from "react-redux";
import DemandDetail from "./demandDetail";
import { getServiceDetail } from "../../../redux/actions/newService/serviceDetail.actions";
import { showAlertPopup } from "../../../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import { downloadFiles } from "../../../redux/actions/fileAttachment/fileAttachment.actions";
import { addDemandAction } from "../../../redux/actions/demand/demand.action";
import { setActiveSecondaryTab } from "../../../redux/actions/userManagement/userManagementTab.action";
import { openAlertPopup } from "../../../redux/actions/Alert/alert.action";
import { getLocations } from "../../../redux/actions/newService/locations.action";

const mapStateToProps = (state) => {
  return {
    myRights : state.myRights.myRights,
    demandDetail: state.newService.serviceDetail.serviceDetail,
    isLoading:state.newService.serviceDetail.loading,
    activeSecondaryTab :state.tabReducer.activeSecondaryTab,
    isLoading:state.newService.serviceDetail.loading,
    locations: state.newService.locations.locations.locations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
           getServiceDetail: (requestId)=>{
            return dispatch(getServiceDetail(requestId))
        },  
          showAlertPopup: (alertHeader,alertmessage) => {
            return dispatch(showAlertPopup(alertHeader,alertmessage))
        },
          downloadFile:(originalFileName,uniqueFileName)=>{
            return dispatch(downloadFiles(originalFileName,uniqueFileName))
        },
         addDemandAction: (payload,id)=>{
            return dispatch(addDemandAction(payload,id))
        },
        setActiveSecondaryTab: (tab) => {
          return dispatch(setActiveSecondaryTab(tab))
        },
        openAlertPopup: (payload) => {
          return dispatch(openAlertPopup(payload))
        },
         getLocations: () => {
          return dispatch(getLocations())
        },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DemandDetail);